import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityItem } from "../../entity/EntityItem";

export class DtoItemsGetReq extends EntityItem {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------
    if (!commonRegx.isMatch(this.c_item_id!.toString(), "^\\d+$", commonRegx._stdOption)) {
      res.push("type error");
    }

    return res;
  }
}
